import React from "react";

// images
import { Link } from "react-router-dom";

const LastPost = ({ data }) => {
  return (
    <Link
      to={`/news/${data.slug}`}
      className="w-full h-auto bg-gray-800 bg-opacity-40 flex items-center gap-3 p-2 group rounded-xl"
    >
      {/* post image */}
      <div>
        <img
          className="max-w-[80px] max-h-[80px] min-w-[80px] min-h-[80px] object-cover rounded-square group-hover:rounded-xl transition-all duration-300"
          src={`https://api.myunibest.com/${data.image}`}
          alt=""
        />
      </div>

      {/* post details */}
      <div className="w-full flex flex-col text-[13px] gap-2 text-slate-700">
        <h3 className="last-post-title text-gray-200 relative text-[16px] font-semibold group-hover:before:!w-[97%]">
          {data.title}
        </h3>
        <span className="text-gray-400">
          {new Intl.DateTimeFormat("fa-IR", {
            year: "numeric",
            month: "short",
            day: "numeric",
          }).format(new Date(data.updated_at))}
        </span>
      </div>
    </Link>
  );
};

export default LastPost;
